import { useEffect, useState } from "react";
import GoogleLogin from "./GoogleLogin";
import Captcha from "../../common/Captcha";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { createOtp, googleWithLogin } from "../../store/slices/user";
import { useDispatch } from "react-redux";
import VerifyOtp from "./VerifyOtp";
import FullPageLoader from "../../common/FullPageLoader";


interface EmailUserProps {
    // setShowMobileLinks: any;
    // setShowEmailLinks: any;
    // showCaptcha: any;
    setShowText:any
}

function EmailUser(props: EmailUserProps) {

    const validEmailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    const [loading, setLoading] = useState(false);
    const [reloadCaptcha, setReloadCaptcha] = useState(1);
    const [searchParams] = useSearchParams();
    const [userId, setUserId] = useState<string>('');
    const [showVerify, setShowVerify] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [inputField, setInputField] = useState<any>({
        email: "",
        password: "",
        captcha: "",
        hash: "",
        mobile: "",
        resendOtp: false
    });

    const [otp, setOtp] = useState("");

    const [errField, setErrField] = useState<any>({
        email: "",
        password: "",
        isCaptchaInvalid: false,
        captchaError: "",
        captcha: "",
        otp: ""
    });

     useEffect(() => {
        const userDataParam: any = searchParams.get('userdata');        

        if (userDataParam) {
            try {
                setLoading(true);
                const parsedData = JSON.parse(decodeURIComponent(userDataParam));

                if ((!parsedData.domain && parsedData.email) || parsedData.domain !== "Invalid") {
                    setLoading(true);
                    setInputField({ ...inputField, email: parsedData.email, password: "", captcha: '' });

                    googleWithLogin({...parsedData, "loginType": "googleLogin"}, dispatch)
                        .then(async (result: any) => {
                            if (result.status === 200) {
                                    navigate('/dashboard');
                                    // HELPER.navigatePermssion(navigate);
                            }else{
                                setLoading(false);
                                setInputField({ ...inputField, email: "", password: "", captcha: '' });
                                navigate('/login');
                            }
                        })
                } else {
                    setLoading(false);
                    toast.error("Invalid credentials.")
                    navigate('/login');

                }

            } catch (error) {
                setLoading(false);
                toast.error("Invalid credentials.")
                navigate('/login');
            }
        }
        // eslint-disable-next-line
    }, [searchParams]); 
    const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === "otp") {
            setOtp(value);
        }
        else {
            setInputField({ ...inputField, [name]: value });
        }
        errField[name] = '';
        setErrField({ ...errField });
    };

    
    const submitButton = async () => {

        setLoading(true);
        if (validForm()) {

            createOtp(inputField).then((res:any) => {
                
                setLoading(false)
                if (res && res.data && res.status === 200) {
                    //DELETE CAPTCHA HASH FROM CACHE 
                    setUserId(res && res.data && res.data.user_id);
                    setShowVerify(true);
                    props.setShowText(true)
                    // props.setShowEmailLinks(true);
                    // props.setShowMobileLinks(false);

                }
                setReloadCaptcha((prev) => prev + 1)
                setInputField({ ...inputField, email: inputField.email, password: inputField.password, captcha: '' })

            });
        } else {
            setReloadCaptcha((prev) => prev + 1)
            setLoading(false);
        }
    };

    const validForm = () => {
        let formIsValid = true;
        setErrField({
            email: "",
            password: "",
            isCaptchaInvalid: false,
            captchaError: "",
            captcha: "",
            otp: ""
        });

        if (inputField.email === "") {

            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                email: "Email is required",
            }));
        } else if (!validEmailRegex.test(inputField.email)) {

            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                email: "Please enter valid email",
            }));
        }
        if (inputField.password === "") {

            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                password: "Password is required",
            }));
        }
        if (!inputField['captcha'].trim()) {

            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                captcha: "Captcha is required",
            }));
            setReloadCaptcha((prev) => prev + 1)
        }

        return formIsValid;
    };

    const captchaFiledHandler = (captchaValue: string, captchaImage: any) => {
        if (captchaImage.data) {
            setInputField({ ...inputField, captcha: captchaValue, hash: captchaImage.data.value });
        }
    };


    return (
        <div className="login-form">
            <FullPageLoader show={loading} />
            {
                showVerify ?

                    (<VerifyOtp submitButton={submitButton} userId={userId} inputField={inputField} otp={otp} />)
                    :
                    <form autoComplete="on">
                        <fieldset className="">
                            <div className="material">
                                <GoogleLogin />
                            </div>
                        </fieldset>

                        <fieldset className="">
                            <div className="t-centre">
                                <label className='m-md-t'>OR</label>
                            </div>
                        </fieldset>


                        <fieldset>
                            <div className={"material " + (errField.email ? "error" : "")} >
                                <input
                                    type="text"
                                    placeholder=" "
                                    name="email"
                                    className="form-input"
                                    value={inputField.email}
                                    onChange={inputHandler}
                                />
                                <i className="ic-email1 icn-login"></i>
                                <label data-label="Email" className="form-label"></label>
                                {errField.email && (
                                <span className="error-txt">
                                    {errField['email'] || ""}
                                </span>
                                )}
                            </div>
                        </fieldset>
                        <fieldset>
                            <div className={"material " + (errField.password ? "error" : "")}>
                                <input
                                    type="password"
                                    placeholder=" "
                                    name="password"
                                    className="form-input password-txt"
                                    value={inputField.password}
                                    onChange={inputHandler}
                                />
                                <i className="ic-password icn-login"></i>
                                <label data-label="Password" className="form-label"></label>
                                 {errField.password && (
                                <span className="error-txt">
                                    {errField['password'] || ""}
                                </span>
                                )}
                            </div>
                        </fieldset>
                        <fieldset className=" captcha-filed">
                            {/* <Captcha onKeyPressCaptcha={captchaFiledHandler} errField={errField} inputField={inputField} reloadCaptcha={reloadCaptcha || props.showCaptcha} /> */}
                             <Captcha onKeyPressCaptcha={captchaFiledHandler} errField={errField} inputField={inputField} reloadCaptcha={reloadCaptcha} />
                        </fieldset>

                        <button type="button" className="btn-primary w-100 m-xl-t" onClick={submitButton} >
                            Login
                        </button>

                    </form>
            }

        </div>
    );
}

export default EmailUser;